<template>
	<div style="height:100%;">
		<AppBar />
		<MainMenu />
		<ProfileMenu />
		<MainPanel />
	</div>
</template>

<script>
import AppBar from "./AppBar";
import MainMenu from "./MainMenu";
import ProfileMenu from "./ProfileMenu";
import MainPanel from "./MainPanel";
export default {
	components: { AppBar, MainMenu, ProfileMenu, MainPanel }
};
</script>
